module.exports = __webpack_public_path__ + "img/mobile-2.69be80e4.jpg";